<template>
  <div class="topbar"><!-- Navbar -->
    <nav class="navbar-custom" :style="checkWidth ? navMarginLeft : mobNavMarginLeft">
      <ul class="list-unstyled topbar-nav float-right mb-0 mr-3">
        <!-- <li class="hidden-sm">
          <a class="nav-link dropdown-toggle waves-effect waves-light" data-toggle="dropdown"
             href="javascript: void(0);" role="button" aria-haspopup="false"
             aria-expanded="false">{{ languages[locale].label }}
            <img :src="languages[locale].iconSrc" class="ml-2" height="16" alt="">
            <i class="dripicons-chevron-down"></i></a>
          <div class="dropdown-menu dropdown-menu-right">
            <a v-for="(language, lngCode) in languages"
               :key="lngCode"
               @click.prevent="changeLocale(lngCode)" class="dropdown-item" href="">
              <span>{{ language.label }}</span>
              <img :src="language.iconSrc" alt="" class="ml-2 float-right" height="14">
            </a>
          </div>
        </li> -->
        <!-- <li class="dropdown notification-list">
          <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#"
             role="button" aria-haspopup="false" aria-expanded="false">
            <i class="dripicons-bell"></i> <span class="badge badge-danger badge-pill noti-icon-badge">2</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-lg pt-0">
            <h6
              class="dropdown-item-text font-15 m-0 py-3 bg-primary text-white d-flex justify-content-between align-items-center">
              Ծանուցումներ
              <span class="badge badge-light badge-pill">2</span>
            </h6>
            <div class="slimScrollDiv" style="position: relative; overflow: hidden; width: auto; height: 937px;">
              <div class="slimscroll notification-list" style="overflow: hidden; width: auto; height: 937px;">
                <a href="#" class="dropdown-item py-3">
                  <small class="float-right text-muted pl-2">2 min ago</small>
                  <div class="media">
                    <div class="avatar-md bg-primary">
                      <i class="la la-cart-arrow-down text-white"></i>
                    </div>
                    <div class="media-body align-self-center ml-2 text-truncate">
                      <h6 class="my-0 font-weight-normal text-dark">Your order is placed</h6>
                      <small class="text-muted mb-0">Dummy text of the printing and industry.</small>
                    </div>
                  </div>
                </a>
                <a href="#"
                   class="dropdown-item py-3">
                  <small class="float-right text-muted pl-2">10 min ago</small>
                  <div class="media">
                    <div class="avatar-md bg-success">
                      <i class="la la-group text-white"></i>
                    </div>
                    <div class="media-body align-self-center ml-2 text-truncate">
                      <h6 class="my-0 font-weight-normal text-dark">Meeting with designers</h6>
                      <small class="text-muted mb-0">It is a long established fact that a reader.</small>
                    </div>
                  </div>
                </a>
                <a href="#" class="dropdown-item py-3">
                  <small class="float-right text-muted pl-2">40 min ago</small>
                  <div class="media">
                    <div class="avatar-md bg-pink"><i class="la la-list-alt text-white"></i></div>
                    <div class="media-body align-self-center ml-2 text-truncate">
                      <h6 class="my-0 font-weight-normal text-dark">UX 3 Task complete.</h6>
                      <small class="text-muted mb-0">Dummy text of the printing.</small>
                    </div>
                  </div>
                </a>
                <a href="#" class="dropdown-item py-3">
                  <small class="float-right text-muted pl-2">1 hr ago</small>
                  <div class="media">
                    <div class="avatar-md bg-warning"><i class="la la-truck text-white"></i></div>
                    <div class="media-body align-self-center ml-2 text-truncate">
                      <h6 class="my-0 font-weight-normal text-dark">Your order is placed</h6>
                      <small class="text-muted mb-0">It is a long established fact that a reader.</small>
                    </div>
                  </div>
                </a>

                <a href="#" class="dropdown-item py-3">
                  <small class="float-right text-muted pl-2">2 hrs ago</small>
                  <div class="media">
                    <div class="avatar-md bg-info"><i class="la la-check-circle text-white"></i></div>
                    <div class="media-body align-self-center ml-2 text-truncate">
                      <h6 class="my-0 font-weight-normal text-dark">Payment Successfull</h6>
                      <small class="text-muted mb-0">Dummy text of the printing.</small>
                    </div>
                  </div>
                </a>
              </div>
              <div class="slimScrollBar"
                   style="background: rgba(162, 177, 208, 0.13); width: 7px; position: absolute; top: 0px; opacity: 1; display: block; border-radius: 7px; z-index: 99; right: 1px;"></div>
              <div class="slimScrollRail"
                   style="width: 7px; height: 100%; position: absolute; top: 0px; display: none; border-radius: 7px; background: rgb(51, 51, 51); opacity: 0.2; z-index: 90; right: 1px;"></div>
            </div>
            <a href="javascript:void(0);" class="dropdown-item text-center text-primary">View all <i
              class="fi-arrow-right"></i></a>
          </div>
        </li> -->
        <li class="dropdown">
          <a class="dropdown-toggle waves-effect waves-light nav-user" style="height: 70px;" data-toggle="dropdown" href="#" aria-haspopup="false" aria-expanded="false">
            <!--                    <img src="/assets/dashboard/assets/images/users/user-4.jpg" alt="profile-user" class="rounded-circle">-->
            <div v-if="me.organisation" class="h-100 row align-items-center">
              <div v-if="userType === 'STATE'" class="col pt-3 mob-hide">
                <p class="ml-1 nav-user-name hidden-sm">
                 «{{ me.organisation[0].translations.name.hy }}»
                 <template v-if="me.organisation[0].translations.company_type.hy">
                   {{ me.organisation[0].translations.company_type.hy }}
                 </template>
                 <br>
                 {{ me.name }}
                </p>
              </div>
              <div v-else class="col">
                <p class="m-0 mob-hide">
                  <template v-if="me.organisation[0].translations.company_type.hy">
                    «{{ me.name }}» 
                    {{ me.organisation[0].translations.company_type.hy }}
                  </template>
                  <template v-else>
                    {{ me.name }}
                  </template>
                </p>
              </div>
              <div class="col">
                <span
                  class="p-2 badge badge-pill badge-primary" 
                  :class="
                    me.package === 'Գոլդ' ? 'badge-warning' : 
                    me.package === 'Պրեմիում' ? 'badge-success' :
                    me.package === 'Էկոնոմ' ? 'badge-secondary' : 'badge-primary'
                  "
                >
                {{me.package}}
              </span>
              </div>
              <div class="col row align-items-center">
                <div class="col">
                  <i class="dripicons-chevron-down"></i>
                </div>
              </div>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" @click.prevent="$router.push('/settings')" id="settings_detail_tab"
               href="#settings_detail" data-toggle="pill"><i class="dripicons-gear text-muted mr-2"></i> Անձնական
              տվյալներ</a>
            <!-- <div class="dropdown-divider"></div> -->
            <a class="dropdown-item" @click.prevent="$store.dispatch('logout')" href="javascript:void(0)">
              <i class="dripicons-exit text-muted mr-2"></i> Ելք համակարգից
            </a>
          </div>
        </li>
        <!--            <li class="mr-2">-->
        <!--                <a href="#" class="nav-link" data-toggle="modal" data-animation="fade" data-target=".modal-rightbar">-->
        <!--                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"-->
        <!--                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"-->
        <!--                     class="feather feather-align-right align-self-center">-->
        <!--                    <line x1="21" y1="10" x2="7" y2="10"></line>-->
        <!--                    <line x1="21" y1="6" x2="3" y2="6"></line>-->
        <!--                    <line x1="21" y1="14" x2="3" y2="14"></line>-->
        <!--                    <line x1="21" y1="18" x2="7" y2="18"></line>-->
        <!--                </svg>-->
        <!--            </a></li>-->
      </ul><!--end topbar-nav-->
      <ul class="list-unstyled topbar-nav mb-0">
        <li>
          <a href="#">
            <span class="responsive-logo">
                <img src="/assets/dashboard/assets/images/logo-sm.png" alt="logo-small"
                     class="logo-sm align-self-center" height="34">
            </span>
          </a>
        </li>
        <li>
          <button @click="$store.dispatch('settings/toggleInnerMenu')"
                  class="mob-menu button-menu-mobile nav-link waves-effect waves-light">
            <svg width="16" height="16" fill="#1e7bb7" class="mob-menu-item bi bi-caret-left-fill" viewBox="0 0 16 16">
              <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
            </svg>
            <svg width="16" height="16" fill="#1e7bb7" class="mob-menu-item bi bi-caret-right-fill" viewBox="0 0 16 16">
              <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
            </svg>
          </button>
        </li>
        <li :key="actionsKey" class="dropdown" v-if="currentPageActions">
          <a class="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" href="#"
             role="button" aria-haspopup="false" aria-expanded="false">
            <span class="ml-1 p-2 bg-soft-classic nav-user-name hidden-sm rounded">Գործողություններ<i
              class="dripicons-chevron-down"></i></span>
          </a>
          <div class="dropdown-menu dropdown-menu-left py-2">
            <a v-for="action in currentPageActions"
               @click.prevent="() => {action.call ? action.call() : ''}"
               :key="action.title"
               class="dropdown-item mb-2"
               href="">
               <template v-if="action.title !== 'correction' && action.title !== 'negotiations'">
                 <template>
                  <span class="text-primary mr-3">
                    <i :class="action.iconClass"></i>
                  </span>
                  <span>{{ action.title }}</span>
                 </template>
               </template>
               <template v-else>
                  <div v-if="action.title === 'correction'" @click.prevent.stop="handleIsWithCorrection" class="checkbox checkbox-primary pl-1">
                    <input id="correction" :checked="correction" type="checkbox">
                    <label for="correction" class="pl-3 text-primary">Շտկում</label>
                  </div>
                  <div v-else @click.prevent.stop="handleIsWithNegotiations" class="checkbox checkbox-primary pl-1">
                    <input id="negotiations" :checked="negotiations" type="checkbox">
                    <label for="negotiations" class="pl-3 text-primary">Բանակցություններ</label>
                  </div>
               </template>
            </a>
          </div>
        </li>
        <li class="dropdown" v-if="currentPageDocs">
          <a class="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" href="#"
             role="button" aria-haspopup="false" aria-expanded="false">
            <span class="ml-1 p-2 bg-soft-classic nav-user-name hidden-sm rounded">Փաստաթղթեր <i
              class="dripicons-chevron-down"></i></span>
          </a>
          <div class="dropdown-menu dropdown-menu-left py-2">
            <a v-for="document in currentPageDocs"
               :key="document.title"
               @click.prevent="document.call"
               class="dropdown-item mb-2"
               :class="document.disabled && document.disabled() ? 'disabled' : document.main_doc && 'font-weight-bold'"
               href="">
              <span class="text-primary mr-3">
                <i class="fas fa-file-download"></i>
              </span>
              <span>{{ document.title }}</span>
            </a>
          </div>
        </li>
      </ul>
      <ul v-if="userType === 'STATE'" class="d-none d-xl-block list-unstyled topbar-nav mb-0">
          <div style="height: 70px" class="row align-items-center">
            <button
                @click="handleOpenSupportModal"
                type="button"
                class="btn btn-primary rounded-pill uitooltip"
              >
                <i class="fa fa-phone mr-1 fa-flip-horizontal" ></i>
                Օգնություն
              </button>
          </div>
      </ul>
    </nav>
    <!-- end navbar-->
  </div>
</template>
<script>
  export default {
    name: 'TheTopbar',
    props: ['innerMenuWidth'],
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      locale() {
        return this.$store.getters['user/locale']
      },
      navMarginLeft() {
        return { marginLeft: `calc(${this.$store.getters['settings/innerMenuIsClosed'] ? '70px' : '(' + this.innerMenuWidth + ' + 70px)'})` }
      },
      mobNavMarginLeft() {
        return { marginLeft: `calc(${this.$store.getters['settings/innerMenuIsClosed'] ? '70px' : '70px'})` }
      },
      userType(){
          return this.$store.getters.userType
      },
      currentPageActions() {
        const action = this.$route.path.split('/')[1]
        if(action === 'organizator'){
          const organizeType = this.$route.path.split('/')[2]
          const page = this.$route.path.split('/')[3]
          if(organizeType === 'itender'){
            return this.actions[organizeType][page]
          }
        }
        if(action === 'organizing'){
          const organizeType = this.$route.path.split('/')[2]
          const page = this.$route.path.split('/')[3]
          if(organizeType === 'competitive' && page === 'application-evaluation'){
            if(!this.negotiations){
              const indexOfSameLastParticipant = this.actions[organizeType][page].indexOf(this.actions[organizeType][page].find((item) => item.title === "Անցում բանակցությունների"))
              return [
                {title: 'correction'},
                {title: 'negotiations'},
                ...this.actions[organizeType][page].filter((value, index) => index !== indexOfSameLastParticipant), 
              ]
            } else {
              return [
                {title: 'correction'},
                {title: 'negotiations'},
                ...this.actions[organizeType][page], 
              ]
            }
          } else {
            return this.actions[organizeType][page]
          }
        } else {
          return false;
        }
      },
      currentOrganized() {
        const organizeType = this.$route.path.split('/')[2]
        if(organizeType === 'competitive'){
          return this.$store.getters['organize/currentOrganized']
        } else if(organizeType === 'itender'){
          return this.$store.getters['organizeItender/currentOrganized']
        } else {
          return this.$store.getters['organizeOnePerson/currentOrganized']
        }
      },
      organizedRows() {
        return this.$store.getters['organize/organizedRows']
      },
      isMandatoryNegotiations() {
        return this.$store.getters['organize/isMandatoryNegotiations']
      },
      currentPageDocs() {
        const action = this.$route.path.split('/')[1]

        if(action === 'organizator'){
          const organizeType = this.$route.path.split('/')[2]
          const page = this.$route.path.split('/')[3]
          if(organizeType === 'itender'){
            return this.documents[organizeType][page]
          }
        }
        if(action === 'organizing'){
          const page = this.$route.path.split('/')[3]
          const organizeType = this.$route.path.split('/')[2]
          if(organizeType === 'oneperson' && page === 'contract-preparation'){
            if(this.isOrganizeHeld){
              return this.documents[organizeType][page+'-held']
            } else {
              return this.documents[organizeType][page+'-declined']
            }
          }
          return this.documents[organizeType][page]
        } else {
          return false;
        }
      }
    },
    data() {
      return {
        checkWidth : null,
        correction: false,
        negotiations: false,
        lots: [],
        isOrganizeHeld: true,
        actionsKey: 0,
        languages: {
          hy: {
            label: 'Հայերեն',
            iconSrc: '/assets/dashboard/assets/images/flags/armenia_flag.jpg',
          },
          ru: {
            label: 'Русский',
            iconSrc: '/assets/dashboard/assets/images/flags/russia_flag.jpg',
          },
        },
        organizedLots:[],
        actions: {
          competitive: {
            'application-evaluation': [
              {
                title: 'Անցում բանակցությունների',
                call: () => {this.$modal.show('negotiations-modal')},
                iconClass: 'fas fa-user-friends'
              },
              {
                title: 'Վերադառնալ հրավերի պատրաստում',
                call: this.backToPrepareInvitation,
                iconClass: 'fas fa-arrow-circle-left'
              },
              // {
              //   title: 'Բացման նիստի կասեցում շտկման նպատակով',
              //   call: () => {this.$modal.show('opening-session-suspension-for-correction-modal')},
              //   iconClass: 'fas fa-exclamation-circle'
              // },
              // {
              //   title: 'Արտահերթ նիստ',
              //   call: () => {this.$modal.show('extraordinary-sitting-modal')},
              //   iconClass: 'fas fa-stopwatch'
              // },
              // {
              //   title: 'Բացման և Գնահատման Նիստի Արդյունքների Ամփոփում',
              //   call: () => {},
              //   iconClass: 'fas fa-poll'
              // },
            ],
            'contract-preparation': [
              {
                title: 'Վերադառնալ հայտերի գնահատում',
                call: this.backToApplicationEvaluation,
                iconClass: 'fas fa-arrow-circle-left'
              },
              {
                title: 'Պայմանագրի կնքում',
                call: () => {
                  this.$modal.show('contract-request-modal')
                },
                iconClass: 'fas fa-file-signature'
              },
            ],
          },
          oneperson: {
            'contract-preparation': [
              {
                title: 'Պայմանագրի կնքում',
                call: () => {
                  this.$modal.show('contract-request-modal')
                },
                iconClass: 'fas fa-file-signature'
              },
            ],
          },
          itender: {
            'contract-preparation': [
              {
                title: 'Գնահատում',
                call: () => {
                  this.$modal.show('winner-evalution-modal')
                },
                iconClass: 'fas fa-paste'
              },
              {
                title: 'Պայմանագրի կնքում',
                call: () => {
                  this.$modal.show('contract-request-modal')
                },
                iconClass: 'fas fa-file-signature'
              },
            ],
          },
        },
        documents: {
          competitive: {
            'prepare-invitation': [
              {
                title: 'Գնահատող հանձնաժողովի հրաման',
                call: () => {this.$modal.show('evaluator-committee-modal')}
              },
              {
                title: 'Արձանագրություն N 1',
                call: () => {
                  if(!this.currentOrganized.translations.evaluator_president.name){
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Խնդրում ենք լրացնել գնահատող հանձնաժողովի հրամանը, փաստաթուղթը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  } else {
                    this.$modal.show('new-editor-modal', {
                      action: 'save',
                      fileName: 'protocol_number_one',
                      editorTitle: 'Արձանագրություն N 1'
                    })
                  }
                }
              },
              {
                title: 'Պայմանագիր (հայերեն)',
                call: () => {
                  if(!this.currentOrganized.confirm){
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Խնդրում ենք հաստատել ընթացակարգը, փաստաթուղթը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  } else {
                    if(this.currentOrganized.evaluator_secretary_email === ""){
                      this.$fire({
                        title: "Զգուշացում",
                        text: "Պահպանեք գնահատող հանձնաժողովի հրամանը հրավերը ստանալու համար",
                        type: "error",
                        confirmButtonText: 'Լավ'
                      })
                    } else {
                      if(+this.currentOrganized.cpv_type === 3){
                       if(+this.currentOrganized.is_construction){
                          this.$modal.show('new-editor-modal', {
                            action: 'save',
                            fileName: 'contract_draft_work_construction',
                            editorTitle: 'Պայմանագրի նախագիծ'
                          })
                        } else {
                          this.$modal.show('new-editor-modal', {
                            action: 'save',
                            fileName: 'contract_draft_work',
                            editorTitle: 'Պայմանագրի նախագիծ'
                          })
                        }
                      } else if(+this.currentOrganized.cpv_type === 1){
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_product',
                          editorTitle: 'Պայմանագրի նախագիծ'
                        })
                      } else {
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_service',
                          editorTitle: 'Պայմանագրի նախագիծ'
                        })
                      }
                    }
                  }
                }
              },
              {
                title: `Պայմանագիր (ռուսերեն)`,
                call: () => {
                  if(!this.currentOrganized.confirm){
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Խնդրում ենք հաստատել ընթացակարգը, փաստաթուղթը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  } else {
                    if(+this.currentOrganized.cpv_type === 3){
                      if(+this.currentOrganized.is_construction){
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_work_construction_ru',
                          editorTitle: 'Պայմանագրի'
                        })
                      }else {
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_work_ru',
                          editorTitle: 'Договор'
                        })
                      }
                    } else if(+this.currentOrganized.cpv_type === 1){
                      this.$modal.show('new-editor-modal', {
                        action: 'save',
                        fileName: 'contract_draft_product_ru',
                        editorTitle: 'Договор'
                      })
                    } else {
                      this.$modal.show('new-editor-modal', {
                        action: 'save',
                        fileName: 'contract_draft_service_ru',
                        editorTitle: 'Պայմանագիր'
                      })
                    }
                  }
                }
              },
              {
                title: 'Գնման հայտ (մրցկացային)',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'purchase_request',
                    editorTitle: 'Գնման հայտ (մրցկացային)'
                  })
                }
              },
              {
                title: 'Գրանցամատյան',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'scrapbook',
                    editorTitle: 'Գրանցամատյան'
                  })
                }
              },
              // {
              //   title: 'Պայմանագիր (ռուսերեն)',
              //   call: () => {
              //     this.$modal.show('editor-modal', {
              //       fileName: 'contract',
              //       lng: 'ru',
              //       editorTitle: 'Պայմանագիր'
              //     })
              //   }
              // },
              {
                title: 'Հրավեր (հայերեն)',
                main_doc: true,
                call: () => {
                  if(this.currentOrganized.evaluator_secretary_email === ""){
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Պահպանեք գնահատող հանձնաժողովի հրամանը հրավերը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  } else if(this.currentOrganized.contract_html_hy === ""){
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Պահպանեք պայմանագիրը (հայերեն) հրավերը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  } else{
                    this.$modal.show('editor-modal', {
                      fileName: 'invitation',
                      action: 'download',
                      editorTitle: 'Հրավեր'
                    })
                  }
                }
              },
              {
                title: 'Հրավեր (ռուսերեն)',
                main_doc: true,
                call: () => {
                  if(this.currentOrganized.contract_html_ru === ""){
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Պահպանեք պայմանագիրը (ռուսերեն) հրավերը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  }else{
                    this.$modal.show('editor-modal', {
                      fileName: 'invitation',
                      lng: 'ru',
                      action: 'download',
                      editorTitle: 'Հրավեր'
                    })
                  }
                }
              }
            ],
            'application-evaluation': [
              {
                title: 'Ծանուցում բանակցությունների վերաբերյալ',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'save',
                    fileName: 'notice_of_negotiations',
                    editorTitle: 'Ծանուցում բանակցությունների վերաբերյալ'
                  })
                }
              },
              {
                title: 'Հայտարարություն շահերի բախման մասին',
                disabled: this.checkMandatoryNegotiations,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'statement_of_conflict_of_interest',
                    editorTitle: 'Հայտարարություն շահերի բախման մասին'
                  })
                }
              },
              {
                title: `Գնահատման թերթիկ - դատարկ`,
                disabled: this.checkMandatoryNegotiations,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'evaluation_sheet_empty',
                    editorTitle: `Գնահատման թերթիկ - դատարկ`
                  })
                }
              },
              {
                title: `Գնահատման թերթիկ`,
                disabled: this.checkMandatoryNegotiations,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'evaluation_sheet',
                    editorTitle: `Գնահատման թերթիկ`
                  })
                }
              },
              {
                title: 'Հարցում ՊԵԿ (պատճառաբանված որոշման դեպքում)',
                disabled: this.checkMandatoryNegotiations,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'save',
                    fileName: 'state_revenue_committee_survey',
                    editorTitle: 'Հարցում ՊԵԿ (պատճառաբանված որոշման դեպքում)'
                  })
                }
              },
              {
                title: 'Հայտարարություն չկայացած չափաբաժինների մասին',
                disabled: this.checkMandatoryNegotiations,
                call: () => {
                  if(this.isHasCanceledLotsCompetitive()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'announce_procedure_buy_declined_hy',
                      editorTitle: 'Հայտարարություն չկայացած չափաբաժինների մասին'
                    })
                  } else {
                    this.$fire({
                      text: "Ընթացակարգում չկան չկայացած չափաբաժիններ",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Հայտարարություն չկայացած չափաբաժինների մասին (ռուսերեն)',
                disabled: this.checkMandatoryNegotiations,
                call: () => {
                   if(this.isHasCanceledLotsCompetitive()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'announce_procedure_buy_declined',
                      editorTitle: 'Հայտարարություն չկայացած չափաբաժինների մասին (ռուսերեն)'
                    })
                  } else {
                    this.$fire({
                      text: "Ընթացակարգում չկան չկայացած չափաբաժիններ",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Բացման և գնահատման նիստի արձանագրություն',
                disabled: this.checkMandatoryNegotiations,
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'evaluation_session',
                    editorTitle: 'Բացման և գնահատման նիստի արձանագրություն'
                  })
                }
              },
              {
                title: 'Բացման և գնահատման նիստի արձանագրություն (ռուսերեն)',
                disabled: this.checkMandatoryNegotiations,
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'evaluation_session_ru',
                    editorTitle: 'Բացման և գնահատման նիստի արձանագրություն (ռուսերեն)'
                  })
                }
              },
              {
                title: 'Բացման և գնահատման նիստի արձանագրություն (հայերեն և ռուսերեն)',
                // disabled: this.comingSoon,
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'evaluation_session_mix',
                    editorTitle: 'Բացման և գնահատման նիստի արձանագրություն (հայերեն և ռուսերեն)'
                  })
                }
              },
              
            ],
            'contract-preparation': [
              {
                title: 'Պայմանագիր կնքելու որոշում',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_conc_hy',
                    editorTitle: 'Պայմանագիր կնքելու որոշում'
                  })
                }
              },
              {
                title: 'Պայմանագիր կնքելու որոշում (ռուսերեն)',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_conc',
                    editorTitle: 'Պայմանագիր կնքելու որոշում (ռուսերեն)'
                  })
                }
              },
              {
                title: 'Գնման ընթացակարգի արձանագրություն',
                call: () => {
                  if(this.isGreaterThanMln()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'procurement_procedure_protocol',
                      editorTitle: 'Գնման ընթացակարգի արձանագրություն'
                    })
                  } else {
                    this.$fire({
                      text: "Տվյալ փաստաթուղթը հասանելի է միայն 1մլն. ից բարձր նախահաշվային գնով ընթացակարգերի համար",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Գնման ընթացակարգի արձանագրություն չկայացած',
                call: () => {
                  if(this.isGreaterThanMln()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'procurement_procedure_protocol_declined',
                      editorTitle: 'Գնման ընթացակարգի արձանագրություն չկայացած'
                    })
                  } else {
                    this.$fire({
                      text: "Տվյալ փաստաթուղթը հասանելի է միայն 1մլն. ից բարձր նախահաշվային գնով ընթացակարգերի համար",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Կնքված պայմանագրի մասին հայտարարություն',
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_signed_contract',
                    editorTitle: 'Կնքված պայմանագրի մասին հայտարարություն'
                  })
                }
              },
              {
                title: 'Կնքված պայմանագրի մասին հայտարարություն (ռուսերեն)',
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_signed_contract_ru',
                    editorTitle: 'Կնքված պայմանագրի մասին հայտարարություն (ռուսերեն)'
                  })
                }
              },
            ],
          },
          oneperson: {
            'prepare-invitation': [
              {
                title: 'Պայմանագրի նախագիծ',
                call: () => {
                  if(this.currentOrganized.confirm){
                    if (+this.currentOrganized.cpv_type === 3){
                      if(+this.currentOrganized.is_construction){
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_work_construction',
                          editorTitle: 'Պայմանագրի նախագիծ'
                        })
                      } else {
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_work',
                          editorTitle: 'Պայմանագրի նախագիծ'
                        })
                      }
                    } else if(+this.currentOrganized.cpv_type === 1){
                      this.$modal.show('new-editor-modal', {
                        action: 'save',
                        fileName: 'contract_draft_product',
                        editorTitle: 'Պայմանագրի նախագիծ'
                      })
                    } else {
                      this.$modal.show('new-editor-modal', {
                        action: 'save',
                        fileName: 'contract_draft_service',
                        editorTitle: 'Պայմանագրի նախագիծ'
                      })
                    }
                   
                  } else {
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Խնդրում ենք հաստատել ընթացակարգը, փաստաթուղթը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
            ],
            'contract-preparation-declined': [
              {
                title: 'Գնման հայտ',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'purchase_request',
                    editorTitle: 'Գնման հայտ'
                  })
                }
              },
              {
                title: 'Հայտերի գնահատման նիստի արձանագրություն',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'bid_evaluation_session',
                    editorTitle: 'Հայտերի գնահատման նիստի արձանագրություն'
                  })
                }
              },
              {
                title: 'Հայտարարություն գնման ընթացակարգը չկայացած հայտարարելու մասին',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_procedure_buy_declined',
                    editorTitle: 'Հայտարարություն գնման ընթացակարգը չկայացած հայտարարելու մասին'
                  })
                }
              },
              {
                title: 'Գնման ընթացակարգի արձանագրություն չկայացած',
                call: () => {
                  if(this.isGreaterThanMln()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'procurement_procedure_protocol_declined',
                      editorTitle: 'Գնման ընթացակարգի արձանագրություն չկայացած'
                    })
                  } else {
                    this.$fire({
                      text: "Տվյալ փաստաթուղթը հասանելի է միայն 1մլն. ից բարձր նախահաշվային գնով ընթացակարգերի համար",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
            ],
            'contract-preparation-held': [
              {
                title: 'Գնման հայտ',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'purchase_request',
                    editorTitle: 'Գնման հայտ'
                  })
                }
              },
              {
                title: 'Հրավեր (ծանուցում)',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'save',
                    fileName: 'invitation_notification',
                    editorTitle: 'Հրավեր (ծանուցում)'
                  })
                }
              },
              {
                title: 'Հայտերի գնահատման նիստի արձանագրություն',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'bid_evaluation_session',
                    editorTitle: 'Հայտերի գնահատման նիստի արձանագրություն'
                  })
                }
              },
              {
                title: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_conc',
                    editorTitle: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն'
                  })
                }
              },
              {
                title: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն (ռուսերեն)',
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_conc_ru',
                    editorTitle: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն (ռուսերեն)'
                  })
                }
              },
              {
                title: 'Հայտարարություն չկայացած չափաբաժինների մասին',
                call: () => {
                  if(this.isHasCanceledLots()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'announce_procedure_buy_declined',
                      editorTitle: 'Հայտարարություն չկայացած չափաբաժինների մասին'
                    })
                  } else {
                    this.$fire({
                      text: "Ընթացակարգում չկան չկայացած չափաբաժիններ",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Հայտարարություն չկայացած չափաբաժինների մասին (ռուսերեն)',
                call: () => {
                  if(this.isHasCanceledLots()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'announce_procedure_buy_declined_ru',
                      editorTitle: 'Հայտարարություն չկայացած չափաբաժինների մասին (ռուսերեն)'
                    })
                  } else {
                    this.$fire({
                      text: "Ընթացակարգում չկան չկայացած չափաբաժիններ",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Գնման ընթացակարգի արձանագրություն',
                call: () => {
                  if(this.isGreaterThanMln()){
                    this.$modal.show('new-editor-modal', {
                      action: 'download',
                      fileName: 'procurement_procedure_protocol',
                      editorTitle: 'Գնման ընթացակարգի արձանագրություն'
                    })
                  } else {
                    this.$fire({
                      text: "Տվյալ փաստաթուղթը հասանելի է միայն 1մլն. ից բարձր նախահաշվային գնով ընթացակարգերի համար",
                      type: "info",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
              {
                title: 'Կնքված պայմանագրի մասին հայտարարություն',
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_signed_contract',
                    editorTitle: 'Կնքված պայմանագրի մասին հայտարարություն'
                  })
                }
              },
              {
                title: 'Կնքված պայմանագրի մասին հայտարարություն (ռուսերեն)',
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'announce_signed_contract_ru',
                    editorTitle: 'Կնքված պայմանագրի մասին հայտարարություն (ռուսերեն)'
                  })
                }
              },
            ],
          },
          itender: {
            'prepare-invitation': [
              {
                title: 'Պայմանագրի նախագիծ',
                call: () => {
                  if(this.currentOrganized.confirm){
                    if (+this.currentOrganized.cpv_type === 3){
                      if(+this.currentOrganized.is_construction){
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_work_construction',
                          editorTitle: 'Պայմանագրի նախագիծ'
                        })
                      } else {
                        this.$modal.show('new-editor-modal', {
                          action: 'save',
                          fileName: 'contract_draft_work',
                          editorTitle: 'Պայմանագրի նախագիծ'
                        })
                      }
                    } else if(+this.currentOrganized.cpv_type === 1){
                      this.$modal.show('new-editor-modal', {
                        action: 'save',
                        fileName: 'contract_draft_product',
                        editorTitle: 'Պայմանագրի նախագիծ'
                      })
                    } else {
                      this.$modal.show('new-editor-modal', {
                        action: 'save',
                        fileName: 'contract_draft_service',
                        editorTitle: 'Պայմանագրի նախագիծ'
                      })
                    }
                  } else {
                    this.$fire({
                      title: "Զգուշացում",
                      text: "Խնդրում ենք հաստատել ընթացակարգը, փաստաթուղթը ստանալու համար",
                      type: "error",
                      confirmButtonText: 'Լավ'
                    })
                  }
                }
              },
            ],
            'contract-preparation': [
              // {
              //   title: 'Գնման հայտ',
              //   call: () => {
              //     this.$modal.show('new-editor-modal', {
              //       action: 'download',
              //       fileName: 'purchase_request',
              //       editorTitle: 'Գնման հայտ'
              //     })
              //   }
              // },
              // {
              //   title: 'Հայտերի գնահատման նիստի արձանագրություն',
              //   call: () => {
              //     this.$modal.show('new-editor-modal', {
              //       action: 'download',
              //       fileName: 'bid_evaluation_session',
              //       editorTitle: 'Հայտերի գնահատման նիստի արձանագրություն'
              //     })
              //   }
              // },
              // {
              //   title: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն',
              //   call: () => {
              //     this.$modal.show('new-editor-modal', {
              //       action: 'download',
              //       fileName: 'announce_conc',
              //       editorTitle: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն'
              //     })
              //   }
              // },
              // {
              //   title: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն (ռուսերեն)',
              //   call: () => {
              //     this.$modal.show('new-editor-modal', {
              //       action: 'download',
              //       fileName: 'announce_conc_ru',
              //       editorTitle: 'Պայմանագիր կնքելու որոշման մասին հայտարարություն (ռուսերեն)'
              //     })
              //   }
              // },
              // {
              //   title: 'Հայտարարություն չկայացած չափաբաժինների մասին',
              //   call: () => {
              //     if(this.isHasCanceledLots()){
              //       this.$modal.show('new-editor-modal', {
              //         action: 'download',
              //         fileName: 'announce_procedure_buy_declined',
              //         editorTitle: 'Հայտարարություն չկայացած չափաբաժինների մասին'
              //       })
              //     } else {
              //       this.$fire({
              //         text: "Ընթացակարգում չկան չկայացած չափաբաժիններ",
              //         type: "info",
              //         confirmButtonText: 'Լավ'
              //       })
              //     }
              //   }
              // },
              // {
              //   title: 'Հայտարարություն չկայացած չափաբաժինների մասին (ռուսերեն)',
              //   call: () => {
              //     if(this.isHasCanceledLots()){
              //       this.$modal.show('new-editor-modal', {
              //         action: 'download',
              //         fileName: 'announce_procedure_buy_declined_ru',
              //         editorTitle: 'Հայտարարություն չկայացած չափաբաժինների մասին (ռուսերեն)'
              //       })
              //     } else {
              //       this.$fire({
              //         text: "Ընթացակարգում չկան չկայացած չափաբաժիններ",
              //         type: "info",
              //         confirmButtonText: 'Լավ'
              //       })
              //     }
              //   }
              // },
              // {
              //   title: 'Գնման ընթացակարգի արձանագրություն',
              //   call: () => {
              //     if(this.isGreaterThanMln()){
              //       this.$modal.show('new-editor-modal', {
              //         action: 'download',
              //         fileName: 'procurement_procedure_protocol',
              //         editorTitle: 'Գնման ընթացակարգի արձանագրություն'
              //       })
              //     } else {
              //       this.$fire({
              //         text: "Տվյալ փաստաթուղթը հասանելի է միայն 1մլն. ից բարձր նախահաշվային գնով ընթացակարգերի համար",
              //         type: "info",
              //         confirmButtonText: 'Լավ'
              //       })
              //     }
              //   }
              // },
              {
                title: 'Հաշվետվություն',
                main_doc: true,
                call: () => {
                  this.$modal.show('new-editor-modal', {
                    action: 'download',
                    fileName: 'report',
                    editorTitle: 'Հաշվետվություն'
                  })
                }
              },
              // {
              //   title: 'Կնքված պայմանագրի մասին հայտարարություն (ռուսերեն)',
              //   main_doc: true,
              //   call: () => {
              //     this.$modal.show('new-editor-modal', {
              //       action: 'download',
              //       fileName: 'announce_signed_contract_ru',
              //       editorTitle: 'Կնքված պայմանագրի մասին հայտարարություն (ռուսերեն)'
              //     })
              //   }
              // },
            ],
          }
        },
      }
    },
    created() {
      window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
      window.removeEventListener("resize", this.myEventHandler);
    },
    mounted(){
      if(window.innerWidth <= 1200){
        this.checkWidth = false
      }else{
        this.checkWidth = true
      }
    },
    watch: {
      me(newValue) {
        this.listenForNotifications();
      },
      currentOrganized(newValue) {
        const action = this.$route.path.split('/')[1]
        const organizeType = this.$route.path.split('/')[2]
        const page = this.$route.path.split('/')[3]
        if(action === 'organizing' && organizeType === 'competitive' && page === 'application-evaluation'){
          this.correction = newValue.is_correction
          this.negotiations = newValue.is_negotiations
        }
      },
    },
    methods: {
      getVal(varName) {
        return this[varName];
      },
      listenForNotifications() {
        var channel = this.$pusher.subscribe(`user-${this.me.id}`);
 
        channel.bind('new-notification', (data) => {
          console.log('get new notification');
        });
      },
      handleIsWithCorrection(){
        this.correction = !this.correction;
        this.$client.put(`organize/${this.$route.params.id}`, {is_correction: this.correction}).then(({ status, data }) => {
          // eslint-disable-next-line eqeqeq
          if(status == 200) {
            this.$store.commit('organize/setCurrentOrganized', data.data)
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ինչ որ բան այն չէ',
            text: 'Կրկին փորձեք!'
          })
        })
      },
      handleIsWithNegotiations(){
        this.negotiations = !this.negotiations;
        this.$client.put(`organize/${this.$route.params.id}`, {is_negotiations: this.negotiations}).then(({ status, data }) => {
          if(!this.negotiations){
            const indexOfSameLastParticipant = this.currentPageActions.indexOf(this.currentPageActions.find((item) => item.title === "Անցում բանակցությունների"))
            if(indexOfSameLastParticipant !== -1){
              this.currentPageActions.splice(indexOfSameLastParticipant, 1);
            }
          }
          // eslint-disable-next-line eqeqeq
          if(status == 200) {
            this.$store.commit('organize/setCurrentOrganized', data.data)
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ինչ որ բան այն չէ',
            text: 'Կրկին փորձեք!'
          })
        })
      },
      handleOpenSupportModal(){
        this.$alert(
            "", 
            "", 
            "info", 
            {
                html: `
                  <div style="text-align: justify; font-size:  16px">
                    iTender համակարգում պետական գնման գործընթացների ավտոմատացման համահեղինականներն են «Այ Տենդեր» և «Էյչ Էս Փարթներս» ՍՊ ընկերությունները։ Հարցերի և առաջարկությունների դեպքում դիմել «Էյչ Էս Փարթներս» ՍՊԸ-ի տնօրեն 
                    <b>Հայկ Ղազարյանին</b> <br>
                    <b>հեռ. 094 955 944 </b>
                  </div>
                `,
                confirmButtonText: 'Լավ',
                buttonsStyling: false,
                customClass: {
                  confirmButton: 'btn btn-primary btn-lg',
                },
            }
        ).then(r => {
          console.log(r.value);
        });
      },
      myEventHandler(e) {
        if(e.target.innerWidth <= 1200){
            this.checkWidth = false
        }else{
            this.checkWidth = true
        }
      },
      consoleLog(e){
        console.log(e)
      },
      comingSoon(){
        if(this.me.id === 8068 || this.me.id === 8433 || this.me.id === 302 || this.me.id === 8067){
          return false;
        } else {
          return true;
        }
      },
      disabledInvitation(){
        if(this.currentOrganized.contract_html_hy === ""){
          return true;
        } else {
          return false;
        }
      },
      disabledInvitationRu(){
        if(this.currentOrganized.contract_html_ru === ""){
          return true;
        } else {
          return false;
        }
      },
      checkMandatoryNegotiations(){
        // return this.isMandatoryNegotiations;
        return false;
      },
      checkIsNotMandatoryNegotiations(){
        // return !this.isMandatoryNegotiations;
        return false;
      },
      isGreaterThanMln() {
        var totalPrice = 0;
        this.currentOrganized.organize_rows.forEach((row) => {
          totalPrice += row.count * row.procurement_plan.details[0].unit_amount
        })
        if(totalPrice>1000000){
          return true;
        } else {
          return false;
        }
      },
      isHasCanceledLotsCompetitive() {
        var hasCanceledLot = false;
        this.organizedRows.forEach(row => {
          const hasWinner = Boolean(row.participantsList.find((participant) => participant.winner))
          if(!hasWinner){
            hasCanceledLot = true;
            return true;
          }
        });
        if(hasCanceledLot){
          return true
        } else {
          return false;
        }
      },
      isHasCanceledLots() {
        if(this.currentOrganized.winner_by_lots){
          if(this.currentOrganized.organize_rows.find((item) => item.winner_participant_id === 0 && item.winner_user_id === 0)){
            return true;
          }
        }
        return false;
      },
      backToPrepareInvitation() {
        this.$client.put(`organize/${this.$route.params.id}`, {publication: ''}).then(({ status, data }) => {
          // eslint-disable-next-line eqeqeq
          if(status == 200) {
            this.$store.commit('organize/setCurrentOrganized', data.data)
            this.$router.push('/organizing/competitive')
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ինչ որ բան այն չէ',
            text: 'Կրկին փորձեք!'
          })
        })
      },
      backToApplicationEvaluation() {
        this.$client.put(`organize/${this.$route.params.id}`, {create_contract: 0}).then(({ status, data }) => {
          // eslint-disable-next-line eqeqeq
          if(status == 200) {
            this.$store.commit('organize/setCurrentOrganized', data.data)
            this.$router.push('/organizing/competitive')
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ինչ որ բան այն չէ',
            text: 'Կրկին փորձեք!'
          })
        })
      },
      changeLocale(lngCode) {
        if (lngCode !== this.locale) {
          this.$store.dispatch('user/setLocale', lngCode)
          this.$i18n.locale = this.locale
        }
      },
    },
  }
</script>
<style>
.badge{
  box-shadow: 0 3.5px 7px 0 rgb(80 110 228 / 50%);
}
.nav-pills .nav-link.active{
  background: #1e7bb7 !important;
}
@media only screen and (max-width: 1200px) {
  .mob-menu-item{
    transform: rotate( 90deg);
  }
  .mob-menu{
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    height: 70px; 
    justify-content: center;
  }
}

@media only screen and (max-width: 440px) {
  .mob-hide{
    display: none !important;
  }
}

</style>